export default {"name":"NovaComponents-Select-gui-icu","comments":[],"messages":{"NovaComponents-Select-gui-icu.required.aria":"Required"}}